import { ProgressModal } from "@/components/Elements/Feedback/ProgressModal";
import { TextFieldForm } from "@/components/Elements/Forms/TextFieldForm";
import { InputLabel } from "@/components/Elements/Texts/InputLabel";
import { usePostcode } from "@/features/LG/components/Page1/components/PostcodeForm/api/usePostcode";
import {
  locationAreaState,
  locationDetailState,
  postCodeState,
} from "@/store/propertyState";
import { UseFormReturn } from "react-hook-form";
import { useSetRecoilState } from "recoil";

interface Props {
  form: UseFormReturn<any, any>;
}

export const PostcodeForm: React.FC<Props> = ({ form }) => {
  const postcode = usePostcode();

  const setPostCode = useSetRecoilState(postCodeState);
  const setLocationArea = useSetRecoilState(locationAreaState);
  const setLocationDetail = useSetRecoilState(locationDetailState);

  return (
    <div>
      <ProgressModal open={postcode.isLoading} />
      <InputLabel required label="郵便番号" />
      <TextFieldForm
        form={form}
        name="postCode"
        type="number"
        placeholder="0000000"
        rules={{
          pattern: {
            value: /^[0-9]{7}$/,
            message: "郵便番号は半角数字7桁・ハイフンなしで入力してください",
          },
          onChange: (e: any) => {
            if (e.target.value.length == 7) {
              postcode.fetch(
                {
                  postcode: e.target.value,
                },
                (r) => {
                  setPostCode(e.target.value);
                  setLocationArea(r.addrea_area);
                  setLocationDetail("");
                }
              );
            }
          },
        }}
      />
    </div>
  );
};
